import { Route, Routes } from "react-router-dom";
import AboutUsPage from "../app/components/company/about-us";
import FAQPage from "../app/components/company/faq";
import Casestudy1 from "../app/sections/company/case-study/casestudy-1";
import Casestudy2 from "../app/sections/company/case-study/casestudy-2";
import Casestudy3 from "../app/sections/company/case-study/casestudy-3";
import Casestudy4 from "../app/sections/company/case-study/casestudy-4";
import Industries from "../app/sections/company/industries/industries";
import GalleryPage from "../app/components/company/gallery";
import IconsPage from "../app/components/company/icons";
import PricingPage from "../app/components/company/pricing";
import TeamPage from "../app/components/company/team";
import TestimonialsPage from "../app/components/company/testimonials";
import WhyChooseUsPage from "../app/components/company/why-choose-us";
import MissionVisionPage from "../app/components/IT solutions/mission-vision";
import ServicesPage from "../app/components/IT solutions/services/services";
import ServicesDetailPage from "../app/components/IT solutions/services/detail";
import Customsoftware from "../app/components/IT solutions/services/custom-software";
import Webdevelopment from "../app/components/IT solutions/services/web-development";
import Appdevelopment from "../app/components/IT solutions/services/app-development";
import Ecommercesolutions from "../app/components/IT solutions/services/e-commerce-solutions";
import Digitalmarketing from "../app/components/IT solutions/services/digital-marketing";
import Qualitytesting from "../app/components/IT solutions/services/quality-testing";
import Digitalconsulting from "../app/components/IT solutions/services/digital-consulting";
import Aibotsbusinessautomations from "../app/components/IT solutions/services/ai-bots-business-automations";
import Portfolio1Page from "../app/components/IT solutions/portfolio/portfolio1";
import Portfolio2Page from "../app/components/IT solutions/portfolio/portfolio2";
import PortfolioDetailPage from "../app/components/IT solutions/portfolio/detail";
import BlogGridPage from "../app/components/IT blogs/blog-grid";
import BlogListSidebarPage from "../app/components/IT blogs/blog-list-sidebar";
import BlogDetailPage from "../app/components/IT blogs/blog-detail";
import BlogDetailSidebarPage from "../app/components/IT blogs/blog-detail-sidebar";
import ContactUsPage from "../app/components/contactus/contact-us";
import TermsAndConditions from "../app/sections/company/termscondition/termscondition";
import PrivacyPolicy from "../app/sections/company/privacy/privacy";
import Megamenu from "../app/sections/common/Mega-Menu";
import Mobilemenu from "../app/sections/common/MobileMenu";
import Home1Page from "../app/components/home/index";

function AppRoutes() {
    return (
        <>
            <Routes>
                <Route path="/" element={<Home1Page />} />
                <Route path="/index" element={<Home1Page />} />
                
                <Route path="/about-us" element={<AboutUsPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/gallery" element={<GalleryPage />} />
                <Route path="/icons" element={<IconsPage />} />
                <Route path="/testimonials" element={<TestimonialsPage />} />
                <Route path="/why-choose-us" element={<WhyChooseUsPage />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route path="/team" element={<TeamPage />} />
                <Route path="/mission" element={<MissionVisionPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/services/detail" element={<ServicesDetailPage />} />
                <Route path="/service/custom-software" element={<Customsoftware />} />
                <Route path="/service/web-development" element={<Webdevelopment />} />
                <Route path="/service/app-development" element={<Appdevelopment />} />
                <Route path="/service/e-commerce-solutions" element={<Ecommercesolutions />} />
                <Route path="/service/digital-marketing" element={<Digitalmarketing />} />
                <Route path="/service/quality-testing" element={<Qualitytesting />} />
                <Route path="/service/digital-consulting" element={<Digitalconsulting />} />
                <Route path="/service/ai-bots-business-automations" element={<Aibotsbusinessautomations />} />
                <Route path="/Mega-Menu" element={<Megamenu />} />
              <Route path="/MobileMenu" element={<Mobilemenu />} />
                <Route path="/portfolio" element={<Portfolio1Page />} />
                <Route path="/portfolio2" element={<Portfolio2Page />} />
                <Route path="/portfolio/detail/:id" element={<PortfolioDetailPage />} />
                <Route path="/blogs" element={<BlogGridPage />} />
                <Route path="/blogs/list" element={<BlogListSidebarPage />} />
                <Route path="/blogs/detail-with-sidebar" element={<BlogDetailSidebarPage />} />
                <Route path="/blogs/detail/:id" element={<BlogDetailPage />} />
                <Route path="/contact-us" element={<ContactUsPage />} />
                <Route path="/Casestudy-1" element={<Casestudy1 />} />
                <Route path="/Casestudy-2" element={<Casestudy2 />} />
                <Route path="/Casestudy-3" element={<Casestudy3 />} />
                <Route path="/Casestudy-4" element={<Casestudy4 />} />
                <Route path="/industries" element={<Industries />} />
                <Route path="/termscondition" element={<TermsAndConditions />} />
                <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            </Routes>
        </>
    )
}

export default AppRoutes;